import isEmptyValue from '../utils/is-empty-value';
const validateField = (value, validators, values = {}) => {
  // When the field does not have a mandatory validator, we should skip the rest of the validation when there is no value present.
  const fieldValidators = validators.filter(({
    mandatory
  }) => !isEmptyValue(value) || mandatory);

  // eslint-disable-next-line no-restricted-syntax
  for (const validator of fieldValidators) {
    const message = validator(value, values);
    if (message) return message;
  }
  return null;
};
export const composeValidatorsForSingleField = validators => value => validateField(value, validators);
const composeValidators = validators => values => Object.keys(validators).reduce((obj, key) => {
  const message = validateField(values[key], validators[key], values);
  if (message) {
    // mutate object in place for better performance, we are already creating a new object
    // eslint-disable-next-line no-param-reassign
    obj[key] = message;
  }
  return obj;
}, {});
export default composeValidators;